import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mpro-freemium-pay-wall',
  templateUrl: './freemium-pay-wall.component.html',
  styleUrls: ['./freemium-pay-wall.component.scss'],
})
export class FreemiumPayWallComponent implements OnInit, OnDestroy {
  public isModalOpen: boolean = false;
  isPayWall: boolean = false;
  private subscription: Subscription;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.isPayWall = localStorage.getItem('isFreemiumIntroductionFinished') === 'true';
    this.subscription = this.authService.openFreemiumRequestModal.subscribe(
      (freemiumRequestModal) => {
        this.isModalOpen = false;
        if (
          freemiumRequestModal.isOpen &&
          freemiumRequestModal.requestCategory
        ) {
          this.authService.premiumRequest(freemiumRequestModal.requestCategory);
        }
        this.isModalOpen = freemiumRequestModal.isOpen;
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onModalClose() {
    this.isModalOpen = false;
  }
}
